import { render, staticRenderFns } from "./ModalFrame.vue?vue&type=template&id=527ef158"
import script from "./ModalFrame.vue?vue&type=script&lang=js"
export * from "./ModalFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('527ef158')) {
      api.createRecord('527ef158', component.options)
    } else {
      api.reload('527ef158', component.options)
    }
    module.hot.accept("./ModalFrame.vue?vue&type=template&id=527ef158", function () {
      api.rerender('527ef158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/modals/ModalFrame.vue"
export default component.exports